import React from "react";
import { OrderedMap } from "immutable";
import { SecurityAppSecurityEvents } from "@graylog/enterprise-api";
import useUserDateTime from "hooks/useUserDateTime";
import { useSearchSecurityEvents } from "security-app/hooks/useSecurityEventsAPI";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import EventsRefreshControls from "components/events/events/EventsRefreshControls";
import QueryHelper from "components/common/QueryHelper";
import { useSecurityEventsTableElements } from "security-app/components/SecurityEvents/Alerts/Constants";
import columnRenderers from "security-app/components/SecurityEvents/Alerts/ColumnRenderers";
import useTableElements from "security-app/components/SecurityEvents/Alerts/hooks/useTableComponents";
import AlertsWidgets from "security-app/components/SecurityEvents/Alerts/AlertsWidgets";
import EventsRefreshProvider from "components/events/EventsRefreshProvider";
import parseSecurityEventFilters from "security-app/components/SecurityEvents/Alerts/parseSecurityEventFilters";
import { defaultTimeRange } from "components/events/fetchEvents";
import securityEventsSliceRenderers from "security-app/components/SecurityEvents/Alerts/SliceRenderers";
import EventDefinitionPriorityEnum from "logic/alerts/EventDefinitionPriorityEnum";
import FilterValueRenderers from "./FilterValueRenderers";
const nonInfoPriorities = Object.keys(EventDefinitionPriorityEnum.properties).reverse().filter((key) => key !== String(EventDefinitionPriorityEnum.INFO));
const defaultFilters = OrderedMap({ priority: nonInfoPriorities });
const AlertsEntityTable = () => {
  const { userTimezone } = useUserDateTime();
  const { searchSecurityEvents, securityEventEntitiesKeyFn } = useSearchSecurityEvents(userTimezone);
  const { defaultLayout } = useSecurityEventsTableElements();
  const { bulkSelection, expandedSections } = useTableElements({ defaultLayout });
  const _fetchSlices = (column, query, omFilters) => {
    const { timerange, filter } = parseSecurityEventFilters(omFilters, defaultTimeRange);
    return SecurityAppSecurityEvents.slices({
      include_all: false,
      slice_column: column,
      query,
      filter,
      timerange,
      timezone: userTimezone
    });
  };
  return /* @__PURE__ */ React.createElement(EventsRefreshProvider, null, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "security events",
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "security event" }),
      tableLayout: defaultLayout,
      defaultFilters,
      fetchEntities: searchSecurityEvents,
      fetchSlices: _fetchSlices,
      sliceRenderers: securityEventsSliceRenderers,
      keyFn: securityEventEntitiesKeyFn,
      expandedSectionRenderers: expandedSections,
      entityAttributesAreCamelCase: false,
      filterValueRenderers: FilterValueRenderers,
      columnRenderers,
      bulkSelection,
      topRightCol: /* @__PURE__ */ React.createElement(EventsRefreshControls, null),
      middleSection: AlertsWidgets
    }
  ));
};
export default AlertsEntityTable;
